export function getIsLoading(state){
    return state.ui.isLoading
}

export function getHasError(state){
    return state.ui.hasError
}

export function getErrorMessage(state){
    return state.ui.errorMessage
}

export function getErrorCode(state){
    return state.ui.errorCode
}

export function getUiMessage(state){
    return state.ui
}

export function getError(state){
    return state.ui.error
}


// WEBPACK FOOTER //
// ./src/front/features/ui/selectors.js